import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { NHAPipesModule } from '@nha/pipes';
import { NHAUserProfileMenuModule } from '@nha/components/user-profile-menu';
import { NHAPortalLinkComponent } from './components/portal-link/portal-link.component';
import { portalLinkReducers } from './state/portal-link.reducers';
import { PortalLinkEffects } from './state/portal-link.effects';
import { PortalLinkFacade } from './state/portal-link.facade';
import { NHAAppLauncherComponent } from './app-launcher.component';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		MatButtonModule,
		MatChipsModule,
		MatIconModule,
		MatTabsModule,
		NHAUserProfileMenuModule,
		NHAPipesModule,
		StoreModule.forFeature('app_launcher', portalLinkReducers),
		EffectsModule.forFeature([PortalLinkEffects]),
		NHAAppLauncherComponent,
		NHAPortalLinkComponent
	],
	providers: [PortalLinkFacade],
	exports: [NHAAppLauncherComponent, NHAPortalLinkComponent]
})
export class NHAAppLauncherModule {}
